import { MetaData } from './metadata';
import { Sku } from './sku';
import { SkuFilter } from './sku-filter';

export class SkuSearchDto {
  constructor(
    public searchPhrase: string,
    public filters: SkuFilter,
    public metadata: MetaData,
    public results: Sku[]) { }
}